import { RouteObject } from "react-router-dom";
import { complaintRoutes } from "./complaints";
import { dashboardRoutes } from "./cxDashboard/routes";
import { consumerOnboardingRoutes } from "./consumer-onboarding";


import { consumerManagementRoutes } from "./consumerManagement";
import { disconnectionRoutes } from "./disconnect/routes";
import { paymentRoutes } from "./payments";
import { cxSettingsRoutes } from "./settings/routes";
import { serviceRoutes } from "./services";
import { outstandingRoutes } from "./outstanding";
import { reconnectionRoutes } from "./reconnect/routes";
import { transferRoutes } from "./transfer/routes";
import { cxSelfServiceRoutes } from "./selfService";
export interface CXRoute extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: CXRoute[];
}
export const cxRoutes: CXRoute[] = [
  ...cxSettingsRoutes,
  ...disconnectionRoutes,
  ...reconnectionRoutes,
  ...complaintRoutes,
  ...dashboardRoutes,
  ...consumerOnboardingRoutes,
  ...consumerManagementRoutes,
  ...paymentRoutes,
  ...serviceRoutes,
  ...outstandingRoutes,
  ...reconnectionRoutes,
  ...transferRoutes,
  ...cxSelfServiceRoutes
];
